let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8atXf")).then(() => parcelRequire('gu7eh'));